<!-- prawa autorskie -->
<section class="footerBottom px-15">
    <div class="desctopContent">
        <span class="copy">© Copyrights 2022 - SmarterApps sp. z o.o. Wszelkie prawa zastrzeżone.</span>
    </div>
</section>